import { __awaiter } from "tslib";
let otelModulePromise = null;
// Variable specifier keeps `@opentelemetry/api` from being statically resolved
// by bundlers. supabase-js's tsdown build also post-processes its ESM output
// to inject /* webpackIgnore */ /* turbopackIgnore */ /* @vite-ignore */ on
// this expression — rolldown strips magic comments from source. See PR #2381.
const OTEL_PKG = '@opentelemetry/api';
function loadOtel() {
    if (otelModulePromise === null) {
        otelModulePromise = import(OTEL_PKG).catch(() => null);
    }
    return otelModulePromise;
}
/**
 * For tests only. Resets the cached OpenTelemetry import.
 *
 * @internal
 */
export function _resetOtelCache() {
    otelModulePromise = null;
}
/**
 * Extract trace context from the OpenTelemetry API.
 *
 * Returns null if `@opentelemetry/api` is not installed or there is no active
 * trace context. The dynamic import is cached after the first call.
 *
 * @returns Trace context with traceparent, tracestate, and baggage headers, or null if unavailable
 */
export function extractTraceContext() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const otel = yield loadOtel();
            if (!otel || !otel.propagation || !otel.context) {
                return null;
            }
            const carrier = {};
            otel.propagation.inject(otel.context.active(), carrier);
            const traceparent = carrier['traceparent'];
            if (!traceparent) {
                return null;
            }
            return {
                traceparent,
                tracestate: carrier['tracestate'],
                baggage: carrier['baggage'],
            };
        }
        catch (_a) {
            return null;
        }
    });
}
//# sourceMappingURL=extract.js.map